import { makeStyles } from '@material-ui/core/styles'
import { Corner, IProps } from './Interface'

const getCornerRotation = (corner = Corner.BottomLeft) => {
  const rotation = {
    [Corner.TopLeft]: 90,
    [Corner.TopRight]: 180,
    [Corner.BottomRight]: -90,
    [Corner.BottomLeft]: 0,
    [Corner.MiddleLeft]: 45,
    [Corner.MiddleRight]: -135
  }

  return corner in rotation ? rotation[corner] : rotation[Corner.BottomLeft]
}

export default makeStyles<{}, IProps>({
  root: ({ size, corner, bgColor, shadow, borderRadius }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius,
    height: size,
    width: size,
    boxShadow: shadow ? '-2px 2px 0px 2px rgba(0,0,0,0.1)' : 'unset',
    backgroundColor: bgColor,
    transform: `rotate(${getCornerRotation(corner)}deg)`,
    '&:hover': {
      transition: 'all 0.3s ease',
      boxShadow: ({ shadow }) => (shadow ? '-4px 6px 0px 4px rgba(0,0,0,0.1)' : 'unset')
    }
  }),
  content: {
    display: 'flex',
    transform: ({ corner }) => `rotate(${-getCornerRotation(corner)}deg)`
  }
})
